import { createSlice } from "@reduxjs/toolkit";
import { ENUM_LCS_NAME } from "./enums";

const runningGamesId = JSON.parse(localStorage.getItem("runningGamesId"));

// - основная информация стора о играх
const gamesSlice = createSlice({
  name: "games",
  initialState: {
    favoriteGames: [],
    favoriteGamesId: [],
    excludeDemoMode: [],
    liveGames: [],
    categories: [],
    categoryById: {}, // [id]:{name:"",games:[]}
    providers: [],
    lockCategoryById: true, //флаг что бы setCategoryGamesById не выполнялось быстрее setFillCategoryById
    providersGamesById: {},
    runningGamesId: runningGamesId || [],
    runningGames: [],
    hitGames: [],
    bonusProvider: null,
    bonusGames: [],
    idProvidersLiveGame: [] // список провайдеров лайв игр
  },
  reducers: {
    setProviders(state, newAction) {
      state.providers = newAction.payload;
    },
    setFavoriteGames(state, newAction) {
      const newGame = newAction.payload;
      const newGamesId = newGame.map((el) => el.game_id || el.id);
      state.favoriteGames = newGame;
      state.favoriteGamesId = newGamesId;
      localStorage.setItem(ENUM_LCS_NAME.favoritesId, JSON.stringify(newGamesId));
    },
    addFavoriteGames(state, newAction) {
      const newGame = newAction.payload;
      const newGameId = newGame.game_id || newGame.id;
      if (!state.favoriteGamesId.some((el) => el == newGameId)) {
        state.favoriteGames.push(newGame);
        state.favoriteGamesId.push(newGameId);
      }
      localStorage.setItem(ENUM_LCS_NAME.favoritesId, JSON.stringify(state.favoriteGamesId));
    },
    removeFavoriteGames(state, newAction) {
      const newGame = newAction.payload;
      const newGameId = newGame.game_id || newGame.id;
      state.favoriteGames = state.favoriteGames.filter(
        (el) => el.id != newGameId && el.game_id != newGameId
      );
      state.favoriteGamesId = state.favoriteGamesId.filter((el) => el != newGameId);
      localStorage.setItem(ENUM_LCS_NAME.favoritesId, JSON.stringify(state.favoriteGamesId));
    },

    setExcludeDemoMode(state, newAction) {
      state.excludeDemoMode = newAction.payload;
    },
    setLiveGames(state, newAction) {
      state.liveGames = newAction.payload;
    },
    setGameCategories(state, newAction) {
      state.categories = newAction.payload;
    },
    setFillCategoryById(state, newAction) {
      state.lockCategoryById = false;
      state.categoryById = newAction.payload;
    },
    setCategoryGamesById(state, newAction) {
      const { id, data } = newAction.payload;
      if (!state.categoryById[id]) state.categoryById[id] = { games: [] };
      state.categoryById[id].games = data;
    },
    setProvidersGamesById(state, newAction) {
      const { id, data } = newAction.payload;
      state.providersGamesById[id] = data;
    },
    addRunningGamesId(state, newAction) {
      const runningId = newAction.payload;
      let runningGamesId = state.runningGamesId;

      if (runningGamesId.includes(runningId)) {
        runningGamesId = runningGamesId.filter((el) => el !== runningId);
      }

      runningGamesId.unshift(runningId);
      state.runningGamesId = runningGamesId;
      localStorage.setItem(ENUM_LCS_NAME.runningGamesId, JSON.stringify(runningGamesId));
    },
    setHistoryGames(state, newAction) {
      state.runningGames = newAction.payload;
    },
    setHitGames(state, newAction) {
      state.hitGames = newAction.payload;
    },
    setBonusProvider(state, newAction) {
      state.bonusProvider = newAction.payload;
    },
    setBonusGames(state, newAction) {
      state.bonusGames = newAction.payload;
    },
    setIdProvidersLiveGame(state, newAction) {
      state.idProvidersLiveGame = newAction.payload;
    }
  }
});

export default gamesSlice.reducer;

export const {
  setProviders,
  setBonusGames,
  setGameCategories,
  setFavoriteGames,
  setExcludeDemoMode,
  addRunningGamesId,
  addFavoriteGames,
  removeFavoriteGames,
  setLiveGames,
  setFillCategoryById,
  setCategoryGamesById,
  setProvidersGamesById,
  setHistoryGames,
  setBonusProvider,
  setIdProvidersLiveGame,
  setHitGames
} = gamesSlice.actions;
